import { useContext } from 'react';
import { AuthContext } from '../../contexts/auth';

export default function Footer({modulo, funcao, executa, sair, imprimir}){
  const { usuario, permissoes } = useContext(AuthContext);
        
  return(              
    <footer className='flex gap-4 pt-6 mt-6 mb-6 border-t border-secondary justify-end'>
      {(funcao === 'Consulta') && (modulo === 'Usuário')  && (usuario.per_usuario === 'GS') && (
        <button 
          type='button' 
          className='border border-secondary text-secondary hover:bg-secondary hover:text-white px-10 py-2 rounded-md'
          onClick={gerar}>Gerar Token
        </button>
      )}
      {(funcao === 'Consulta') && (modulo === 'Ordem')  && (permissoes.includes("IMPRIMIR_OM")) && (
        <button 
          type='button' 
          className='border border-secondary text-secondary hover:bg-secondary hover:text-white px-10 py-2 rounded-md'
          onClick={imprimir}>Imprimir
        </button>
      )}
      <button 
        type='submit' 
        className='border border-secondary text-secondary hover:bg-secondary hover:text-white px-10 py-2 rounded-md'
        onClick={executa}>
          {((funcao === 'Consulta') && ('Ok')) ||   
          ((funcao === 'Alteração') && ('Atualizar')) ||
          ((funcao === 'Exclusão') && ('Excluir')) ||
          ((funcao === 'Inclusão') && ('Incluir'))  ||
          ((funcao === 'Perfil') && ('Atualizar')) ||
          ((funcao === 'Gerar') && ('Gerar')) ||
          ((funcao === 'GerarSenha') && ('Gerar'))}
          
      </button>

      {(funcao !== 'Consulta' && funcao !== 'Perfil' && funcao !== 'Gerar')  && (
        <button 
          type='button' 
          className='border border-red-500 text-red-500 hover:bg-red-500 hover:text-white px-10 py-2 rounded-md' 
          onClick={sair}>Cancelar
        </button>
      )}
  </footer>
)
}
